module.exports = __webpack_public_path__ + "4dd00e4770b269296d89a1ca6f7d4d0a.jpg";